import { useEffect } from "react";

// Lightweight page-title + smooth scroll header offset helper
export const PageHeader = ({ overline, title, sub, image }) => (
  <header className="relative pt-40 pb-20 sm:pt-48 sm:pb-28 overflow-hidden border-b border-[#2A201A]">
    {image && (
      <div className="absolute inset-0 -z-10">
        <img src={image} alt="" className="h-full w-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/70 to-obsidian/25" />
      </div>
    )}
    <div className="mx-auto max-w-7xl px-6 sm:px-10">
      {overline && <p className="font-mono text-xs uppercase tracking-[0.35em] text-teal mb-6">{overline}</p>}
      <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-light tracking-tighter leading-[0.9] max-w-4xl">{title}</h1>
      {sub && <p className="mt-8 max-w-2xl text-base sm:text-lg text-[#8F877C] leading-relaxed">{sub}</p>}
    </div>
  </header>
);

// Sets the page's SEO head: document title, meta description, and a
// self-referencing canonical URL on the production domain.
export const useTitle = (t, description) => {
  useEffect(() => {
    document.title = t || "Aurora Springs RP | RedM Roleplay Server";
    if (description) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", description);
    }
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", "https://auroraspringsrp.org" + window.location.pathname);
  }, [t, description]);
};
